// extracted by mini-css-extract-plugin
module.exports = {"link":"info-module--link--YdOie","listItem":"info-module--list-item--1zQn5","icon":"info-module--icon--KxJYv"};